import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { auth } from "../../Api";
import { AutoComplete, Input as AInput } from 'antd';
import 'react-phone-number-input/style.css'
import LocalPhoneField from '../../components/people/localPhoneField'
import { dialCodeFor, toInternational, phoneProblem, formatPhone, phoneWithCount } from '../../utils/phone'
import { formatServerMessage } from '../../utils/serverErrors'
import { personName, isSharedPhoneReply, sharedPhoneState, confirmedSharedPhoneRequest } from '../../utils/people'
import SharedPhoneModal from '../../components/people/sharedPhoneModal'
import { deleteSucceeded, deleteFailedMessage, DELETE_UNREACHABLE } from '../../utils/deleteReply'
import { titleCell } from '../../utils/tables'

const { getCode, getName } = require('country-list');

const TreeTable = treeTableHOC(ReactTable);

class Supervisor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			open: false,
			modal: false,
			obj: {},
			jsonData: [],
			originData: [],
			data: data.makeData(),
			treedata: data.treedata,
			companyName: '',
			defaultCountry: null
		};
		this.toggle = this.toggle.bind(this);
		this.alertToggle = this.alertToggle.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		let companyId = localStorage.getItem('companyId')
		let companyName = localStorage.getItem('companyName')
		auth.getCompany({ id: companyId })
			.then((res) => {
				if (res.data.code == 200) {
					let companyData = res.data.message.users[0];
					this.setState({ defaultCountry: companyData.countrycode, dialCode: dialCodeFor(companyData.countrycode) });
				}
			});
		var req = {}
		req.company_id = companyId
		auth.getSupervisor(req)
			.then((res) => {
				if (res.data.code == 200) {
					this.setState({
						companyName: companyName,
						jsonData: res.data.message.users,
						originData: res.data.message.users
					})
				}
			});
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}
	alertToggle() {
		this.setState({
			alertModal: !this.state.alertModal
		});
	}

	handleChange = (checked) => {
		console.log("checked:", checked)
		this.setState({ checked });
	}

	setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		// A copy, so the field shows what is typed
		this.setState({ obj: Object.assign({}, this.state.obj, { phone: event }) })
	}

	handleSubmit = (event) => {
		// A copy: the list keeps what is saved, not what is typed
		let obj = Object.assign({}, this.state.obj);
		event.preventDefault();
		obj.firstname = event.target.firstname.value;
		obj.secondname = event.target.secondname.value;
		obj.countrycode = this.state.selectedCountry || this.state.defaultCountry;
		// The local number completed with the company's dialling code
		const phone = toInternational(obj.phone, this.state.dialCode);
		if (phone === null) {
			window.alert(phoneProblem(obj.phone, this.state.dialCode))
			return
		}
		obj.phone = phone;
		// The form stays open until the supervisor is saved (a question or a refusal leaves it as typed)
		this.saveQuickEdit(obj)
	}

	// A phone number someone else in the company also has is asked about first (code 409); Yes sends
	// the save again with confirm_shared_phone. Other refusals (e.g. CID already used) are shown.
	saveQuickEdit = (req) => {
		auth.updateSupervisor(req)
			.then((res) => {
				if (isSharedPhoneReply(res)) {
					this.setState({ sharedPhone: sharedPhoneState(res, req, 'supervisor') })
					return
				}
				if (res.data.code != 201) {
					window.alert(formatServerMessage(res.data.message, 'The supervisor could not be saved.'))
					return
				}
				// Saved: back to the list, loaded again
				this.setState({ modal: false })
				this.componentDidMount()
			})
	}

	// samePerson: the person of another kind the admin said this is (Yes), or null (No, or Continue)
	confirmSharedPhone = (samePerson) => {
		const { req } = this.state.sharedPhone
		this.setState({ sharedPhone: null })
		this.saveQuickEdit(confirmedSharedPhoneRequest(req, samePerson))
	}

	// Reloads the list only after the server has deleted it; a refusal is shown
	deleteRow() {
		const { obj } = this.state
		this.setState({ alertModal: false })
		auth.deleteSupervisor(obj)
			.then((res) => {
				if (deleteSucceeded(res)) {
					this.componentDidMount()
				} else {
					window.alert(deleteFailedMessage(res, 'The supervisor could not be deleted.'))
				}
			})
			.catch(() => window.alert(DELETE_UNREACHABLE))
	}

	handleSearch = (value) => {
		console.log(["searchData.length==value:", value])
		var searchData = [];
		this.state.originData.map((prop, key) => {
			if (prop.firstname.toLowerCase().includes(value.toLowerCase())
				|| prop.secondname.toLowerCase().includes(value.toLowerCase())) {
				searchData.push(prop)
			}
		})
		console.log(["searchData.length==00:", searchData.length])
		this.setState({ jsonData: searchData })
	};

	render() {
		const { data, obj, companyName } = this.state;
		const data2 = this.state.jsonData.map((prop, key) => {
			return {
				id: key,
				name: (
					<a onClick={() => { this.props.history.push('/supervisor-info/' + prop.id) }} style={{ cursor: "pointer" }}>{personName(prop, 'supervisor')}</a>
				),
				CID: prop.CID,
				phone: formatPhone(prop.phone),
				// The first number, and "+N" when the person has N more
				phoneShown: phoneWithCount(prop),
				district: prop.district,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						<Switch onChange={this.handleChange} uncheckedIcon checkedIcon offColor="#ddd" checked={this.state.checked} />
					</div>
				),
				edit: (
					<div className="justify-content-center">
						<Button className="btn-table-edit ml-1" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: prop,
								selectedCountry: prop.countrycode,
							});
						}}><i className="mdi mdi-lead-pencil" style={{ color: "white" }} /></Button>
						<Button className="btn-table-remove" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								alertModal: !this.state.alertModal,
								obj: prop,
							});
						}}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
					</div>
				)
			};
		});


		return <div>
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}><h3>Supervisor Edit</h3></ModalHeader>
				{
					obj == {} ? <div></div> : <ModalBody>
						<Form onSubmit={this.handleSubmit}>
							{/* <Input type="hidden" name="id" id="id" defaultValue={obj.id} /> */}
							<FormGroup>
								<Label for="name">First name</Label>
								<Input type="text" name="firstname" id="name" defaultValue={obj.firstname} />
							</FormGroup>
							<FormGroup>
								<Label for="name">Last name</Label>
								<Input type="text" name="secondname" id="name" defaultValue={obj.secondname} />
							</FormGroup>
							<FormGroup>
								<Label for="age">Phone</Label>
								<LocalPhoneField
									dialCode={this.state.dialCode}
									value={obj.phone}
									onChange={this.setPhoneNumber}
									editing={{ kind: 'supervisor', id: obj.id }}
									suggest />
							</FormGroup>
							<FormGroup style={{ textAlign: "center" }}>
								<Button color="primary" className="modal-btn mr-1" type="submit">Save</Button>
								<Button color="secondary" className="modal-btn ml-1" onClick={this.toggle}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>}
			</Modal>
			<Modal isOpen={this.state.alertModal} toggle={this.alertToggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>Delete this supervisor?</h2>
					<div>This deletes the supervisor for good and signs them out of the app. It is refused while clients are still assigned to them. Their guards and duties are kept, without a supervisor.</div>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="modal-btn ml-1" onClick={this.alertToggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" className="modal-btn mr-1" onClick={() => this.deleteRow()}>Yes, Delete It!</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<SharedPhoneModal
				isOpen={this.state.sharedPhone != null}
				message={this.state.sharedPhone ? this.state.sharedPhone.message : ''}
				details={this.state.sharedPhone ? this.state.sharedPhone.details : []}
				person={this.state.sharedPhone ? this.state.sharedPhone.person : null}
				onYes={this.confirmSharedPhone}
				onNo={() => this.confirmSharedPhone(null)}
				onCancel={() => this.setState({ sharedPhone: null })} />
			{/*--------------------------------------------------------------------------------*/}
			{/* Start Action table*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="height-10"></div>
			<Card>
				{/* <CardTitle className="mb-0 p-3 border-bottom bg-light">
				</CardTitle> */}
				<CardBody>
					<Row className="table-header">
						<div className="table-title"><i className="fas fa-users"></i><span> Supervisors - {companyName}</span></div>
						<div style={{ width: 300 }} className="auto-complete">
							<AutoComplete
								dropdownMatchSelectWidth={252}
								style={{
									width: 300,
								}}
								options={[]}
								onSearch={this.handleSearch}
							>
								<AInput size="large" placeholder="Search" />
							</AutoComplete>
						</div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "No",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index + 1}</div>;
								}
							},
							{
								Header: "Name",
								accessor: "name"
							},
							{
								Header: "CID",
								accessor: "CID",
								Cell: titleCell,
							},
							{
								Header: "PHONE",
								accessor: "phoneShown",
								Cell: titleCell,
							},
							{
								Header: "District",
								accessor: "district",
								Cell: titleCell,
							},
							{
								Header: "",
								accessor: "edit",
								minWidth: 100,
								id: "row",
								maxWidth: 100,
								filterable: false,
							},
						]}
						defaultPageSize={10}
						showPaginationBottom={true}
						className="-striped -highlight"
						data={data2}
					// filterable
					/>
					<div className="add-button">
						<a onClick={() => { this.props.history.push('/supervisor-edit/null') }}><Button className="btn" color="primary" size="lg" active>
							<i className="fas fa-user-plus"></i> Add New Supervisor
						</Button></a>
					</div>
				</CardBody>
			</Card>
			{/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
		</div>
	}
}

export default Supervisor;
